function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFertilizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2783"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 385",
    d: "M18 0a18 18 0 1 0 18 18A18.053 18.053 0 0 0 18 0z",
    style: {
      fill: "#26791c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2735",
    d: "M27.575 15.125a9.756 9.756 0 0 1-4.637 11.642 9.862 9.862 0 0 1-.806.384 5.848 5.848 0 0 1-.375 1.138 10.693 10.693 0 0 0 6.788-13.249 8.608 8.608 0 0 0-.97.085",
    transform: "translate(-.086 .62)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2736",
    d: "M15.515 27.8a9.744 9.744 0 0 1-7.756-11.02 5.815 5.815 0 0 1-.788-.9 10.652 10.652 0 0 0 8.151 12.779 8.853 8.853 0 0 0 .393-.859",
    transform: "translate(.795 .571)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2737",
    d: "M29.909 13.05a5.056 5.056 0 0 0-5.709-1.881 5.049 5.049 0 0 0-2.922 5.237c.044.32.193.5.443.527a.351.351 0 0 0 .054 0 .484.484 0 0 0 .425-.259 8.359 8.359 0 0 1 3.271-2.174.377.377 0 0 0 .061-.024 8.333 8.333 0 0 1 3.883-.6.485.485 0 0 0 .526-.136.527.527 0 0 0-.032-.693m-4.749.562a8.614 8.614 0 0 0-2.271 1.2A4.933 4.933 0 0 1 26.2 12.7l-.056-.467a5.484 5.484 0 0 0-3.817 2.55 3.752 3.752 0 0 1 2.215-2.74 3.658 3.658 0 0 1 1.251-.225 4.232 4.232 0 0 1 2.695 1.082 9.237 9.237 0 0 0-3.327.713",
    transform: "translate(-.057 .863)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2738",
    d: "M14.816 15.151a.48.48 0 0 0-.46-.287 8.318 8.318 0 0 1-3.52-1.744.557.557 0 0 0-.053-.04 8.328 8.328 0 0 1-2.458-3.063.484.484 0 0 0-.383-.389c-.251-.047-.443.081-.584.378a5.064 5.064 0 0 0 1.226 5.88 4.507 4.507 0 0 0 2.8.965 5.6 5.6 0 0 0 3.2-1.053.521.521 0 0 0 .234-.648m-5.643 0a3.928 3.928 0 0 1-1.234-3.844 9.235 9.235 0 0 0 2.281 2.525 8.618 8.618 0 0 0 2.172 1.369 4.93 4.93 0 0 1-3.481-1.81l-.378.282A5.487 5.487 0 0 0 12.67 15.7a3.759 3.759 0 0 1-3.5-.544",
    transform: "translate(.783 .937)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2739",
    d: "M17.836 22.018a.52.52 0 0 0-.68.12.485.485 0 0 0-.019.542 8.325 8.325 0 0 1 .251 3.92.388.388 0 0 0-.01.065 8.34 8.34 0 0 1-1.421 3.661.484.484 0 0 0-.148.524.494.494 0 0 0 .523.322h.094a5.059 5.059 0 0 0 4.483-4 5.049 5.049 0 0 0-3.074-5.149m2.144 5.006a3.927 3.927 0 0 1-2.712 2.99 9.21 9.21 0 0 0 1.046-3.238 8.561 8.561 0 0 0 .1-2.566 4.933 4.933 0 0 1 .173 3.921l.432.185a5.486 5.486 0 0 0-.3-4.58 3.75 3.75 0 0 1 1.264 3.288",
    transform: "translate(.263 .215)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2740",
    d: "M19.317 20.813a3 3 0 1 0-1.418.359 3 3 0 0 0 1.418-.359m-3.23-1.66a2.054 2.054 0 1 1 2.783.831 2.056 2.056 0 0 1-2.783-.831",
    transform: "translate(.315 .611)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2741",
    d: "M14.091 7.611a10.649 10.649 0 0 0-4.264 2.753 8.589 8.589 0 0 0 .567.777 9.337 9.337 0 0 1 4.222-2.694 3.786 3.786 0 0 1-.524-.836",
    transform: "translate(.612 1.054)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2742",
    d: "M21.627 7.585a3.785 3.785 0 0 1-.5.82 9.839 9.839 0 0 1 3.085 1.585 5.622 5.622 0 0 1 1.2-.217 10.757 10.757 0 0 0-3.784-2.188",
    transform: "translate(-.049 1.056)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2743",
    d: "M17.824 8.473a2.841 2.841 0 0 0 2.824-2.857C20.649 4.038 17.824 0 17.824 0S15 4.038 15 5.616a2.841 2.841 0 0 0 2.824 2.857m1.257-3.788a.734.734 0 1 1-.726.734.73.73 0 0 1 .726-.734",
    transform: "translate(.309 1.5)",
    style: {
      fill: "#f5f5f5"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFertilizer);
export default __webpack_public_path__ + "static/media/fertilizer.c71574a468f83ec6383aa0d713e8f7ea.svg";
export { ForwardRef as ReactComponent };